import { ListSuperAdminUsersResponseSchema } from './list-superadmin-users.schema';
/**
 * List SuperAdmin Users Endpoint Contract
 * Retrieves all superadmin users (super-admin only)
 */ export const listSuperAdminUsersContract = {
    method: 'GET',
    path: '/api/v2/superadmin-users',
    description: 'Retrieve all superadmin users from the SuperAdmin database',
    responseSchema: ListSuperAdminUsersResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin'
        }
    }
};

//# sourceMappingURL=list-superadmin-users.contract.js.map